import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * The building-level "Documents Log" page was removed — it duplicated the
 * Timeline with no extra value (the "Uploaded today" dashboard widget covers
 * the recent-uploads feed). Old deep links — bookmarks, emails — land here
 * and are forwarded to the Timeline. The query string is preserved so a
 * `?project=` scope carries over.
 */
export function LegacyDocumentsLogRedirect() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  return <Navigate to={`/buildings/${id}/documents${location.search}`} replace />;
}
